import React from 'react'
import {
  checkJapanese,
  checkMobile,
  closeFullscreen,
  exitHandler,
  isSafari,
  isSentryBreadcrumbs,
  toggleFullscreen
} from '../../lib/lib'
import Janus from '../../lib/janus'
import { VideoVolume } from './VideoVolume'
import MicOff from 'material-ui/svg-icons/av/mic-off'
import UserIcon from 'material-ui/svg-icons/social/person'
import './../../App.css'
import { MuteUnMuteButton } from './MuteUmuteButton'
import FullScreen from 'material-ui/svg-icons/navigation/fullscreen'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ExitFullScreen from 'material-ui/svg-icons/navigation/fullscreen-exit'

export default class VideoView extends React.Component {
  constructor (props) {
    super(props)
    this.switchFullScreen = this.props.switchFullScreen.bind(this)
    this.audioMuteToggle = this.props.audioMuteToggle.bind(this)
    this.state = {test: false, ui_visible: false, mute: false, hover: false, isFullScreen: false}
    this.state = {
      width: window.innerWidth / window.screen.width,
      height: window.innerHeight / window.screen.height,
      videoStyle: {},
      aspectRatio: 1.33
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    this.videoRef = React.createRef()
    this.aspectRatio = 1.33
  }

  componentDidMount () {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
    if (this.props.mode == 'breakout' && !this.props.break_join) {
      Janus.attachMediaStream(document.getElementById('myvideo' + this.props.remote_user.id), this.props.remote_user.stream) // TODO: リソース解放
    } else {
      this.updateWindowDimensions()
      window.addEventListener('resize', this.updateWindowDimensions)
      var video = document.getElementById('myvideo' + this.props.remote_user.id)
      if (!(this.props.remote_user.you && this.props.remote_user.audioTag)) { // 自分のaudioタグを入れると反響する
        video.srcObject = this.props.remote_user.stream // webinar or p2p
      }
    }

    if (!this.props.remote_user.audioTag) {
      const videoRef = this.videoRef.current
      videoRef.addEventListener('loadedmetadata', (event) => {
        const borderWidth = event.target.style.borderWidth // 1px => 1
          ? parseInt(event.target.style.borderWidth)
          : 0

        const width = event.target.clientWidth + borderWidth * 2
        const height = event.target.clientHeight + borderWidth * 2
        const top = event.target.offsetTop
        const left = event.target.offsetLeft

        const aspectRatio = Math.round((videoRef.videoWidth / videoRef.videoHeight) * 100) / 100
        if (!(this.props.remote_user.full && this.props.remote_user.screen)) {
          const aspectRatio = Math.round((videoRef.videoWidth / videoRef.videoHeight) * 100) / 100
          this.aspectRatio = aspectRatio
        }

        this.setState({
          videoStyle: {
            position: 'absolute',
            zIndex: -1,
            backgroundColor: '#000',
            width,
            height,
            top,
            left,
            aspectRatio
          }
        })
      })
    }

    if (document.addEventListener) {
      document.addEventListener('webkitfullscreenchange', this.exitHandler, false)
      document.addEventListener('mozfullscreenchange', this.exitHandler, false)
      document.addEventListener('fullscreenchange', this.exitHandler, false)
      document.addEventListener('MSFullscreenChange', this.exitHandler, false)
    }
  }

  toggleHoverOn = (e) => {
    this.setState({hover: true})
  }
  toggleHoverOff = () => { this.setState({hover: false})}

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions () {
    this.setState({
      width: window.innerWidth / window.screen.width,
      height: ((window.innerHeight / window.screen.height) + 0.10)
    })
  }

  toggleScreen = (vid) => {
    this.setState({
      isFullScreen: isSafari() ? false : !this.state.isFullScreen
    }, () => {
      try {
        if (isSafari()) {
          toggleFullscreen(vid)
        } else {
          this.state.isFullScreen ? toggleFullscreen(vid) : closeFullscreen()
        }
      }
      catch (error) {
        const message = 'chat toggleScreen() failed'
        isSentryBreadcrumbs(error, message)
      }
    })
  }
  exitHandler = () => {
    try {
      if (exitHandler()) {
        this.setState({
          isFullScreen: false
        })
      }
    }
    catch (error) {
      const message = 'chat exitHandler() failed'
      isSentryBreadcrumbs(error, message)
    }
  }

  render () {
    const {aspectRatio} = this
    const vidHeight = '94vh'
    const vidWidth = `calc(${vidHeight} * ${aspectRatio})`
    const moveLeftBy = '8vw'
    let marginBottom = 0
    let yourVideoJustifyContent = 'flex-start'
    let dynamicVideoHeight = vidHeight
    const muteUnmuteStyle = {
      zIndex: 2,
      color: 'white',
      fontWeight: 100,
      background: 'transparent',
      border: 'transparent',
      fontSize: '30px',
      position: 'absolute',
      top: 0,
      right: 0,
      backgroundColor: 'rgba(0,0,0,.6)',
      borderRadius: '4px'
    }
    const muteButton = (
      <MuteUnMuteButton
        style={muteUnmuteStyle}
        onMouseEnter={this.toggleHoverOn}
        onClick={(e) => {
          e.stopPropagation()
          this.audioMuteToggle(this.props.remote_user.id, true)
        }}
        mute={false}
      />
    )
    const unmuteButton = (
      <MuteUnMuteButton
        style={muteUnmuteStyle}
        onMouseEnter={this.toggleHoverOn}
        onClick={(e) => {
          e.stopPropagation()
          this.audioMuteToggle(this.props.remote_user.id, false)
        }}
        mute={true}
      />
    )

    let transform = ''
    let displayName
    if (this.props.remote_user.name == 'your_view') {
      transform = 'scaleX(-1)'
      displayName = checkJapanese() ? 'あなたの映像' : 'you view'
    } else {
      displayName = this.props.remote_user.name
    }

    let othersVideoWidth = 10
    if (window.innerHeight == window.screen.height) {
      othersVideoWidth = 6
    }
    if ((this.props.mode == 'breakout' && !this.props.break_join) || this.props.remote_user.audioTag) {
      return (
        <div>
          <audio
            autoPlay
            muted={!this.props.remote_user.hear}
            id={'myvideo' + this.props.remote_user.id}
            style={{display: 'none'}}
            ref={this.videoRef}
          />
        </div>
      )
    }

    let volumePositionStyle = {
      // transform: "translateX(0) translateY(0)"
    }

    let left = 0
    let width = '100vw'
    if (this.props.isOpenDrawer) {
      if (this.props.remote_user.name == 'your_view') {
        yourVideoJustifyContent = 'flex-end'
        // transform += ' translateX(calc(-25% + 3vw))'
        dynamicVideoHeight = `calc(${vidHeight} - ${moveLeftBy})`

        marginBottom = '12vh'
      } else {
        // transform += ' translateX(calc(25% - 3vw))'
        dynamicVideoHeight = `calc(${vidHeight} - ${moveLeftBy})`
        marginBottom = '12vh'
      }
      if (this.props.remote_user.full) {
        volumePositionStyle = {
          // transform: "translateX(-3vw) translateY(-6vh)"
        }
        marginBottom = '12vh'
      }
    }

    if (this.props.remote_user.full && this.props.remote_user.screen) {
      left = '13vw'
      width = '72vw'
      marginBottom = '12vh'
      this.aspectRatio = 1.33

      // if (this.props.isOpenDrawer) {
      //   left = '-3vw'
      //   width = 'calc(100vw - 14vw - 25%)'
      //   if (this.props.remote_user.name == 'your_view') {
      //     transform += ' translateX(calc(-25% + 3vw))'
      //   } else {
      //     transform += ' translateX(calc(25% - 3vw))'
      //   }
      // }
    }

    if (this.props.remote_user.screen) {
      volumePositionStyle = {
        display: 'none'
      }
    }

    return (
      <div
        className="videoCallJoin"
        onMouseEnter={this.toggleHoverOn}
        onMouseUp={this.toggleHoverOn}
        onMouseOver={this.toggleHoverOn}
        onMouseLeave={this.toggleHoverOff}
        style={{position: 'relative', left}}
      >

        {this.props.remote_user.full
          ? <div>
            <button
              className='btn btn-default'
              style={{
                zIndex: 2,
                color: 'white',
                fontWeight: 100,
                background: 'transparent',
                border: 'transparent',
                fontSize: '20px',
                position: 'fixed',
                top: '6vh',
                right: '0vw'
              }}
            >
              {displayName}
            </button>
            <div className="video-wrapper videoMobile-H" style={{
              width,
              transform,
              height: vidHeight,
              transition: '450ms cubic-bezier(0.23, 1, 0.32, 1)'
            }}>
              <div
                className="flex items-center videoMobile-H"
                style={{
                  height: vidHeight,
                  width: vidWidth,
                  justifyContent: yourVideoJustifyContent
                }}
              >
                <div
                  className="mobile-video "
                  style={{
                    height: dynamicVideoHeight,
                    width: `calc(${dynamicVideoHeight} * ${aspectRatio})`,
                    position: 'relative',
                    marginBottom
                  }}>
                  {!this.props.isSharing && !this.props.remote_user.you && this.props.remote_user.mute && unmuteButton}
                  {!this.props.isSharing && !this.props.remote_user.you && !this.props.remote_user.mute && muteButton}
                  <div className="" style={{
                    ...this.state.videoStyle,
                    position: 'absolute',
                    right: this.props.remote_user.name == 'your_view' ? 0 : 'initial',
                    top: 'initial',
                    bottom: 0,
                    zIndex: 10,
                    width: 'auto',
                    height: 'auto',
                    backgroundColor: 'transparent',
                    left: this.props.remote_user.name == 'your_view' ? 'initial' : 0
                  }}>
                    {(!isSafari() && !this.props.remote_user.screen) && <VideoVolume
                      remoteUser={this.props.remote_user}
                      volumePositionStyle={volumePositionStyle}
                    />}
                  </div>
                  <div id={'myvideo_check' + this.props.remote_user.id}>
                    <video
                      className={this.state.isFullScreen ? 'rounded centered video-centered videoAbsl' : 'rounded centered video-centered mobile-video videoAbsl'}
                      id={'myvideo' + this.props.remote_user.id}
                      style={{
                        zIndex: 0,
                        height: this.state.isFullScreen ? '100%' : dynamicVideoHeight,
                        width: this.state.isFullScreen ? '100%' : `calc(${dynamicVideoHeight} * ${aspectRatio})`,
                        display: this.props.muteVideo ? 'none' : 'block',
                        position: 'absolute',
                        objectFit: this.state.isFullScreen ? 'fill' : 'contain'
                      }}
                      autoPlay
                      playsInline
                      muted={this.props.remote_user.mute}
                      ref={this.videoRef}
                    >
                    </video>
                    {!this.props.remote_user.first &&
                    <div className="fullbtnScreen"
                         style={this.state.isFullScreen ? {} : this.props.remote_user.name == 'your_view' ? {left: '10px'} : {}}>
                      <FloatingActionButton
                        backgroundColor={'rgb(1, 153, 68)'}
                        onClick={() => {
                          this.toggleScreen(isSafari() ? 'myvideo' + this.props.remote_user.id : 'myvideo_check' + this.props.remote_user.id)
                        }}
                        iconStyle={{fill: '#FFFFFF'}}
                      >
                        {!this.state.isFullScreen ? <FullScreen style={{height: '56px'}}/> : <ExitFullScreen
                          style={{height: '56px'}}/>}
                      </FloatingActionButton></div>}
                  </div>
                  {(() => {
                    if (this.props.muteVideo) {
                      return (
                        <div style={{
                          width: '100%',
                          height: '100%',
                          background: '#000',
                          textAlign: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                          <div style={{
                            background: '#97b0d9',
                            width: (100 * 1 / 2) + 'vh',
                            height: (100 * 1 / 2) + 'vh',
                            borderRadius: '50%'
                          }}>
                            <UserIcon style={{
                              color: '#55627f',
                              width: (100 * 1 / 2) + 'vh',
                              height: (100 * 1 / 2) + 'vh',
                              borderRadius: '50%'
                            }}></UserIcon>
                          </div>
                        </div>
                      )
                    }
                  })()}
                  <MicOff style={{
                    background: 'red',
                    width: 30,
                    height: 30,
                    color: '#FFF',
                    position: 'absolute',
                    bottom: 0,
                    display: this.props.muteAudio ? 'block' : 'none',
                    right: (this.props.remote_user.name == 'your_view') ? 'auto' : 0

                  }}></MicOff>
                </div>
              </div>
            </div>
          </div>
          : <div>
            <div className="mobile-video position-absolute"
                 style={{
                   width: othersVideoWidth + 'vw'
                 }}
            >
              <div style={{
                ...this.state.videoStyle,
                position: 'absolute',
                top: 'initial',
                bottom: 0,
                zIndex: 10,
                width: 'auto',
                height: 'auto',
                backgroundColor: 'transparent',
                left: 0
              }}>
                {(!isSafari() && !this.props.isJitsi && !this.props.remote_user.screen) && <VideoVolume
                  remoteUser={this.props.remote_user}
                  volumePositionStyle={volumePositionStyle}
                />}
              </div>
              {!this.props.remote_user.you && this.props.remote_user.mute && unmuteButton}
              {!this.props.remote_user.you && !this.props.remote_user.mute && muteButton}
              <div id={'myvideo_multiple' + this.props.remote_user.id}>
                <video
                  className='rounded centered'
                  id={'myvideo' + this.props.remote_user.id}
                  playsInline
                  style={{
                    overflow: 'hidden',
                    width: '100%',
                    transform: transform,
                    height: this.state.isFullScreen ? '100% !important' : '100%',
                    border: '1px solid black',
                    objectFit: this.state.isFullScreen ? 'fill' : 'contain',
                    display: this.props.muteVideo ? 'none' : 'block'
                  }}
                  autoPlay
                  muted={this.props.remote_user.mute}
                  ref={this.videoRef}
                  onClick={(e) => {
                    e.stopPropagation()
                    this.switchFullScreen(this.props.remote_user.id)
                  }}
                />
                {!this.props.remote_user.first &&
                <div className="fullScreen_btn">
                  <FloatingActionButton
                    backgroundColor={'rgb(1, 153, 68)'}
                    className={checkMobile() ? 'btnScreenMob' : 'btnScreen'}
                    onClick={() => {
                      this.toggleScreen(isSafari() ? 'myvideo' + this.props.remote_user.id : 'myvideo_multiple' + this.props.remote_user.id)
                    }}
                    iconStyle={{fill: '#FFFFFF'}}
                  >
                    {!this.state.isFullScreen ? <FullScreen
                      style={checkMobile() ? {height: '25px'} : {height: '40px'}}/> : <ExitFullScreen
                      style={checkMobile() ? {height: '25px'} : {height: '40px'}}/>}
                  </FloatingActionButton></div>}
              </div>
              <MicOff style={{
                background: 'red',
                width: 20,
                height: 20,
                position: 'absolute',
                right: 0,
                bottom: 0,
                color: '#FFF',
                display: this.props.muteAudio ? 'block' : 'none'
              }}></MicOff>
            </div>
            {(() => {
              if (this.props.muteVideo) {
                return (
                  <div
                    onClick={(e) => {
                      e.stopPropagation()
                      this.switchFullScreen(this.props.remote_user.id)
                    }}
                    style={{
                      height: (othersVideoWidth * 3 / 4) + 'vw',
                      background: '#000',
                      textAlign: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}>
                    <div style={{
                      background: '#97b0d9',
                      width: (othersVideoWidth * 1 / 2) + 'vw',
                      height: (othersVideoWidth * 1 / 2) + 'vw',
                      borderRadius: '50%'
                    }}>
                      <UserIcon style={{
                        color: '#55627f',
                        width: (othersVideoWidth * 1 / 2) + 'vw',
                        height: (othersVideoWidth * 1 / 2) + 'vw',
                        borderRadius: '50%'
                      }}></UserIcon>
                    </div>
                    {!this.props.remote_user.you && this.props.remote_user.mute && unmuteButton}
                    {!this.props.remote_user.you && !this.props.remote_user.mute && muteButton}
                  </div>
                )
              }
            })()}
          </div>}
        <div className="mobile-video" style={this.state.videoStyle}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/SeminarMode/VideoView.js